import React from 'react';

const Pop = props => {
    return (
        <div>
            <p>On coming soon  !!</p>
        </div>
    )
}
export default Pop;